import React from 'react';
import styled from 'styled-components';
import Icon from './Icon';
import { Container } from '../styles/variables';
import projects from '../projects';

// Build design for mobile versions
// Build design for desktop version
// Build design for contact
// Make animation wen component visible once

const ProjectCtn = styled.div`
  margin-top: 105px;
  margin-left: 15px;
  margin-right: 15px;
  font-family: Montserata, sans-serif;
  font-weight: 300;
  font-size: 0.8rem;
  padding: 20px;
  transition: 300ms linear 0s;
  background-color: #463055;
  border-radius: 10px;
  cursor: pointer;

  .project-desk-info-ctn {
    display: none;
  }

  .project-img-ctn {
    display: flex;
    justify-content: center;
  }

  .mob-project-title {
    font-family: inherit;
    font-size: 1rem;
    color: var(--card-text-white);
  }

  .mob-project-description {
    font-weight: 400;
    font-size: 0.9rem;
    color: var(--card-text-white);
  }

  .mob-lang-tools {
    font-weight: 400;
    font-size: 0.8rem;
    margin-right: 1rem;
    white-space: nowrap;
    margin-bottom: 0;
  }

  .project-mob-links {
    display: flex;
    flex-direction: row;
    gap: 20px;
    margin-top: 10px;
  }

  .tools-wrap {
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
  }

  svg {
    color: #cec6ca;
    width: 20px;
    height: 20px;
    transition: all 300ms linear 0s;

    &:hover {
      cursor: pointer;
      color: rgba(205, 128, 247, 0.74);
    }
  }

  .image-pjct {
    width: 100%;
    border-radius: 5px;
    transition: all 300ms linear 0s;
  }

  .project-mob-links {
    margin-top: 20px;
  }

  :hover .image-pjct {
    filter: grayscale(0%) brightness(1);
  }

  @media (min-width: 768px) {
    display: flex;
    justify-content: center;
    flex-direction: ${(props) => {
    if (props.flip % 2 === 0) {
      return 'row';
    }
    return 'row-reverse';
  }};
    background-color: unset;

    .project-mob-info-ctn {
      display: none;
    }

    .tools-wrap {
      display: flex;
      flex-direction: row;
      flex-flow: wrap;
      justify-content: ${(props) => {
    if (props.flip % 2 === 0) {
      return 'flex-end';
    }
    return 'flex-start';
  }};
      margin-left: ${(props) => {
    if (props.flip % 2 === 0) {
      return '50px';
    }
    return '0';
  }};
      padding-right: ${(props) => {
    if (props.flip % 2 === 0) {
      return '0';
    }
    return '50px';
  }};;
    };
    
    .image-pjct {
      width: 500px;
      z-index: -1;
      margin-left: ${(props) => {
    if (props.flip % 2 === 0) {
      return '20%';
    }
    return '-20%';
  }};
      filter: grayscale(100%) brightness(0.5);
    }

    .project-desk-info-ctn {
      align-self: center;
      display: block;
      width: 50%;
    }

    .desk-project-title {
      font-size: 1rem;
      color: rgba(240, 248, 255, 0.96);
    }

    .desk-project-description {
      font-weight: 400;
      font-size: 1rem;
      color: rgba(240, 248, 255, 0.96);
    }

    .desk-project-card {
      display: flex;
      background-color: #40224b;
      border-radius: 10px;
      box-shadow: ${(props) => {
    if (props.flip % 2 === 0) {
      return '-2px 0 3px rgba(65, 61, 66, 0.58)';
    }
    return '2px 0 3px rgba(65, 61, 66, 0.58)';
  }};;
    }

    .desk-project-info {
      background-color: #463055;
      padding: 15px;
      border-radius: 10px;
    }

    .desk-project-links {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: end;
      gap: 15px;
      margin-left: 10px;
      margin-right: 10px;
      bottom: 15px;
    }
  }
`;

function Project() {
  return (
    <Container id="work">
      {projects.map((project, index) => (
        <ProjectCtn key={project.title} flip={index}>
          <div className="project-img-ctn">
            <img className="image-pjct" src={project.image} alt="project_image" />
          </div>
          <div className="project-mob-info-ctn">
            <div className="mob-project-info">
              <h4 className="mob-project-title">{project.title}</h4>
              <h4 className="mob-project-description">{project.description}</h4>
              <div className="tools-wrap">
                {project.languageTools.map((tool) => (
                  <h4 key={tool.toString()} className="mob-lang-tools">{tool}</h4>
                ))}
              </div>
              <div className="project-mob-links">
                {project.linkGithub
                  && (
                    <a href={project.linkGithub} target="_blank" rel="noopener noreferrer">
                      <Icon name="github" />
                    </a>
                  )}
                {project.liveDemo
                  && (
                    <a href={project.liveDemo} target="_blank" rel="noopener noreferrer">
                      <Icon name="external" />
                    </a>
                  )}
              </div>
            </div>
          </div>
          <div className="project-desk-info-ctn">
            <div className="desk-project-card">
              <div className="desk-project-info">
                <h4 className="desk-project-title">{project.title}</h4>
                <h4 className="desk-project-description">{project.description}</h4>
              </div>
              <div className="desk-project-links">
                {project.linkGithub
                  && (
                    <a href={project.linkGithub} target="_blank" rel="noopener noreferrer">
                      <Icon name="github" />
                    </a>
                  )}
                {project.liveDemo
                  && (
                    <a href={project.liveDemo} target="_blank" rel="noopener noreferrer">
                      <Icon name="external" />
                    </a>
                  )}
              </div>
            </div>
            <div className="tools-wrap">
              {project.languageTools.map((tool) => (
                <h4 key={tool.toString()} className="mob-lang-tools">{tool}</h4>
              ))}
            </div>
          </div>
        </ProjectCtn>
      ))}
    </Container>

  );
}

export default Project;
